module.exports = __webpack_public_path__ + "img/map.66b3d600.jpg";